module.exports = __webpack_public_path__ + "img/养老.3b406c46.png";